import { size } from "../../../../utils/size";
export var getAreNavigationItemsGrouped = function getAreNavigationItemsGrouped(navigationItems) {
  return navigationItems.some(function (_ref) {
    var subItems = _ref.subItems;
    return size(subItems);
  });
};